export default "__VITE_ASSET__BrOqSD_s__"